import { Box } from '@mui/material'
import CoverageChart from './ChartSection/CoverageChart'
import CoverageScorecard from './ChartSection/CoverageScorecard'
import { SvgCaret } from './components/DropDown'
import InformationSection from './InformationSection'
import { H2 } from './MethodologyAndMetrica.styled'
import { Fragment, useState } from 'react'

const MethodologyAndMetrics = () => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <Box width={'100%'} padding={'0 8px'}>
      <Box width={'100%'} display='flex' alignItems={'center'} flexDirection={'column'} justifyContent={'center'}>
        <Box width={'100%'} maxWidth={1550}>
          <Box
            width={'100%'}
            mb={'40px'}
            display='flex'
            alignItems={'center'}
            sx={{ cursor: 'pointer' }}
            onClick={() => setIsOpen(!isOpen)}
          >
            <H2 style={{ display: 'inline', marginBottom: 0, fontWeight: '400' }} className='methodologyHeading'>Methodology and Metrics</H2>
            <SvgCaret open={isOpen} />
          </Box>
          {isOpen ? <InformationSection /> : null}
        </Box>
      </Box>
      {isOpen ? (
        <Fragment>
          <Box height={'80px'} />
          <CoverageScorecard />
          <Box height={'60px'} />
          <Box width={'100%'} display='flex' alignItems={'center'} flexDirection={'column'} justifyContent={'center'}>
            <Box width={'100%'} maxWidth={1550} alignSelf={'center'} marginBottom={5}>
              <CoverageChart />
            </Box>
          </Box>
        </Fragment>
      ) : null}
    </Box>
  )
}

export default MethodologyAndMetrics
